import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check local storage for existing token/user data on mount
    const storedUser = localStorage.getItem('linyuan_user');
    const storedToken = localStorage.getItem('linyuan_token');

    // If there is user data but no token (or invalid token check if possible), clear it
    if (storedUser && !storedToken) {
      localStorage.removeItem('linyuan_user');
      setUser(null);
    } else if (storedUser && storedToken) {
      try {
        // Active check: Decode token to check expiration
        const base64Url = storedToken.split('.')[1];
        if (base64Url) {
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
            const payload = JSON.parse(jsonPayload);
            
            const currentTime = Date.now() / 1000;
            if (payload.exp && payload.exp < currentTime) {
                console.warn("Token expired, clearing session");
                localStorage.removeItem('linyuan_user');
                localStorage.removeItem('linyuan_token');
                setUser(null);
            } else {
                setUser(JSON.parse(storedUser));
            }
        } else {
             // Fallback if token format is weird but exists
             setUser(JSON.parse(storedUser));
        }
      } catch (e) {
        console.error("Failed to parse stored user data or token", e);
        localStorage.removeItem('linyuan_user');
        localStorage.removeItem('linyuan_token'); // Also clear token if user data is corrupted
        setUser(null);
      }
    }
    setLoading(false);

    // Listen for logout events from api interceptor
    const handleLogoutEvent = () => {
        logout();
    };
    window.addEventListener('auth:logout', handleLogoutEvent);

    return () => {
        window.removeEventListener('auth:logout', handleLogoutEvent);
    };
  }, []);

  const login = (userData) => {
    setUser(userData);
    localStorage.setItem('linyuan_user', JSON.stringify(userData));
    if (userData.token) {
        localStorage.setItem('linyuan_token', userData.token);
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('linyuan_user');
    localStorage.removeItem('linyuan_token');
  };

  const updateUser = (updates) => {
      setUser(prev => {
          const newUser = { ...prev, ...updates };
          localStorage.setItem('linyuan_user', JSON.stringify(newUser));
          return newUser;
      });
  }

  return (
    <AuthContext.Provider value={{ user, login, logout, updateUser, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
